import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Form, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import ExportExcel from "../../utility/ExportCSV";
import enableTableSearch from "../../utility/tableSearch";
import { authFetch } from "../../utility/AuthFetch";

function ExamCategoryTable({ onEdit, reload }) {
  const [entries, setEntries] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        setLoading(true);
        const response = await authFetch(`${API_BASE_URL}/api/exam-category`);
        const result = await response.json();
        setEntries(result.exam_categories || []);
      } catch (error) {
        console.error("Error fetching entries:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEntries();
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No exam found",
    });

    return cleanup;
  }, [loading]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <ExportExcel
          tableId="examCategoryTable"
          filename="exam_category_report.xlsx"
        />
        <Form.Control
          type="text"
          placeholder="Search"
          style={{ width: "200px" }}
          ref={inputRef}
        />
      </div>

      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table striped bordered hover id="examCategoryTable" ref={tableRef}>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Type</th>
              <th>Name</th>
              <th>Maximum Marks</th>
              <th>Annual Percentage</th>
              <th>Annual Percentage With Practical</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              entries.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button variant="warning" onClick={() => onEdit(item)}>
                      EDIT
                    </Button>
                  </td>
                  <td>{item.type}</td>
                  <td>{item.name}</td>
                  <td>{item.marks}</td>
                  <td>{item.annualPercentage}</td>
                  <td>{item.annualPercentWithPractical}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default ExamCategoryTable;
